//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'CMS',
        data: () => {
            return {
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                var width = 0;
                setInterval(function () {
                    var div=document.getElementById("icon");
                    if(width==0){
                        div.style.width="20%";
                        div.style.height="29%";
                        div.style.top="18%";
                        div.style.left="67.5%";
                        width = 1;
                    }else{
                        div.style.width="22%";
                        div.style.height="31%";
                        div.style.top="18%";
                        div.style.left="66.5%";
                        width = 0;
                    }
                },300);
            },
            getTickt(){
                window.location.href = 'https://qr.alipay.com/cpx18988p61s5uebd14ff49';
            },
            goMini(){
                window.location.href='https://qr.alipay.com/s6x04348cttjw1kxw5nkf09';
            }

        }
    }




// WEBPACK FOOTER //
// ./src/page/miniUrl/alipay.vue